/* tslint:disable */
/* eslint-disable */
/**
 * Reckon Bolt API
 * Backend API for Reckon Bolt
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
    import type {
        AddAccount,
        AgentVariableDistribution200ResponseInner,
        PatchedPlayer,
        Player,
        PlayerAggregate,
    } from '../models/index';

            export interface AddPlayerAccountRequest {
                id: string;
                add_account?: AddAccount;
            }

            export interface PlayerAggregateRequest {
                groupby: Array<string>;
                ordering: Array<string>;
                additional_filters?: object;
                aggregates?: Array<string>;
                birthdate?: string;
                contract_expires?: string;
                current_team?: string;
                domestic_league?: string;
                grid_id?: number;
                having?: object;
                id?: string;
                index_on?: string;
                is_retired?: boolean;
                last_team?: string;
                metrics?: Array<string>;
                nationality?: string;
                previous_names?: string;
                role?: string;
                soloq_tracked?: boolean;
                vlr_id?: number;
            }

            export interface PlayerCreateRequest {
                id: string;
                player: Player;
            }

            export interface PlayerFieldValuesRequest {
                field: string;
                ordering: Array<string>;
                additional_filters?: object;
                birthdate?: string;
                contract_expires?: string;
                current_team?: string;
                domestic_league?: string;
                grid_id?: number;
                id?: string;
                is_retired?: boolean;
                last_team?: string;
                nationality?: string;
                previous_names?: string;
                role?: string;
                soloq_tracked?: boolean;
                vlr_id?: number;
            }

            export interface PlayerGetRequest {
                id: string;
            }

            export interface PlayerListRequest {
                additional_filters?: object;
                annotations?: Array<string>;
                birthdate?: string;
                contract_expires?: string;
                current_team?: string;
                domestic_league?: string;
                grid_id?: number;
                id?: string;
                is_retired?: boolean;
                last_team?: string;
                nationality?: string;
                only_values?: Array<string>;
                ordering?: Array<string>;
                previous_names?: string;
                role?: string;
                soloq_tracked?: boolean;
                vlr_id?: number;
            }

            export interface PlayerPatchRequest {
                id: string;
                patched_player?: PatchedPlayer;
            }

            export interface PlayerVariableDistributionRequest {
                bucket_size: number;
                max: number;
                metric: string;
                min: number;
                additional_filters?: object;
                birthdate?: string;
                contract_expires?: string;
                current_team?: string;
                domestic_league?: string;
                grid_id?: number;
                id?: string;
                is_retired?: boolean;
                last_team?: string;
                nationality?: string;
                previous_names?: string;
                role?: string;
                soloq_tracked?: boolean;
                vlr_id?: number;
            }

        /**
        * 
        */
            export class PlayerApi extends runtime.BaseAPI {

            /**
            */
            async addPlayerAccountRaw(requestParameters: AddPlayerAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling addPlayerAccount.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                    headerParameters['Content-Type'] = 'application/json';

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/Player/item/{id}/add_account`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
                                body: requestParameters.add_account,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async add_account(requestParameters: AddPlayerAccountRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.addPlayerAccountRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async playerAggregateRaw(requestParameters: PlayerAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PlayerAggregate>>> {
                    if (requestParameters.groupby === null || requestParameters.groupby === undefined) {
                    throw new runtime.RequiredError('groupby','Required parameter requestParameters.groupby was null or undefined when calling playerAggregate.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling playerAggregate.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.aggregates) {
                        queryParameters['aggregates'] = requestParameters.aggregates;
                    }

                    if (requestParameters.birthdate !== undefined) {
                            queryParameters['birthdate'] = requestParameters.birthdate;
                    }

                    if (requestParameters.contract_expires !== undefined) {
                            queryParameters['contract_expires'] = requestParameters.contract_expires;
                    }

                    if (requestParameters.current_team !== undefined) {
                            queryParameters['current_team'] = requestParameters.current_team;
                    }

                    if (requestParameters.domestic_league !== undefined) {
                            queryParameters['domestic_league'] = requestParameters.domestic_league;
                    }

                    if (requestParameters.grid_id !== undefined) {
                            queryParameters['grid_id'] = requestParameters.grid_id;
                    }

                    if (requestParameters.groupby) {
                        queryParameters['groupby'] = requestParameters.groupby;
                    }

                    if (requestParameters.having !== undefined) {
                            queryParameters['having'] = requestParameters.having;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.index_on !== undefined) {
                            queryParameters['index_on'] = requestParameters.index_on;
                    }

                    if (requestParameters.is_retired !== undefined) {
                            queryParameters['is_retired'] = requestParameters.is_retired;
                    }

                    if (requestParameters.last_team !== undefined) {
                            queryParameters['last_team'] = requestParameters.last_team;
                    }

                    if (requestParameters.metrics) {
                        queryParameters['metrics'] = requestParameters.metrics;
                    }

                    if (requestParameters.nationality !== undefined) {
                            queryParameters['nationality'] = requestParameters.nationality;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.previous_names !== undefined) {
                            queryParameters['previous_names'] = requestParameters.previous_names;
                    }

                    if (requestParameters.role !== undefined) {
                            queryParameters['role'] = requestParameters.role;
                    }

                    if (requestParameters.soloq_tracked !== undefined) {
                            queryParameters['soloq_tracked'] = requestParameters.soloq_tracked;
                    }

                    if (requestParameters.vlr_id !== undefined) {
                            queryParameters['vlr_id'] = requestParameters.vlr_id;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/Player/operations/aggregate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async aggregate(requestParameters: PlayerAggregateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PlayerAggregate>> {
                    const response = await this.playerAggregateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async playerCreateRaw(requestParameters: PlayerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling playerCreate.');
                    }

                    if (requestParameters.player === null || requestParameters.player === undefined) {
                    throw new runtime.RequiredError('player','Required parameter requestParameters.player was null or undefined when calling playerCreate.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                    headerParameters['Content-Type'] = 'application/json';

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/Player/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
                                body: requestParameters.player,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async create(requestParameters: PlayerCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player> {
                    const response = await this.playerCreateRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async playerFieldValuesRaw(requestParameters: PlayerFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
                    if (requestParameters.field === null || requestParameters.field === undefined) {
                    throw new runtime.RequiredError('field','Required parameter requestParameters.field was null or undefined when calling playerFieldValues.');
                    }

                    if (requestParameters.ordering === null || requestParameters.ordering === undefined) {
                    throw new runtime.RequiredError('ordering','Required parameter requestParameters.ordering was null or undefined when calling playerFieldValues.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.birthdate !== undefined) {
                            queryParameters['birthdate'] = requestParameters.birthdate;
                    }

                    if (requestParameters.contract_expires !== undefined) {
                            queryParameters['contract_expires'] = requestParameters.contract_expires;
                    }

                    if (requestParameters.current_team !== undefined) {
                            queryParameters['current_team'] = requestParameters.current_team;
                    }

                    if (requestParameters.domestic_league !== undefined) {
                            queryParameters['domestic_league'] = requestParameters.domestic_league;
                    }

                    if (requestParameters.field !== undefined) {
                            queryParameters['field'] = requestParameters.field;
                    }

                    if (requestParameters.grid_id !== undefined) {
                            queryParameters['grid_id'] = requestParameters.grid_id;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.is_retired !== undefined) {
                            queryParameters['is_retired'] = requestParameters.is_retired;
                    }

                    if (requestParameters.last_team !== undefined) {
                            queryParameters['last_team'] = requestParameters.last_team;
                    }

                    if (requestParameters.nationality !== undefined) {
                            queryParameters['nationality'] = requestParameters.nationality;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.previous_names !== undefined) {
                            queryParameters['previous_names'] = requestParameters.previous_names;
                    }

                    if (requestParameters.role !== undefined) {
                            queryParameters['role'] = requestParameters.role;
                    }

                    if (requestParameters.soloq_tracked !== undefined) {
                            queryParameters['soloq_tracked'] = requestParameters.soloq_tracked;
                    }

                    if (requestParameters.vlr_id !== undefined) {
                            queryParameters['vlr_id'] = requestParameters.vlr_id;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/Player/operations/field-values`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse<any>(response);
            }

            /**
            */
                async field_values(requestParameters: PlayerFieldValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
                    const response = await this.playerFieldValuesRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async playerGetRaw(requestParameters: PlayerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling playerGet.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/Player/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async get(requestParameters: PlayerGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player> {
                    const response = await this.playerGetRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async playerListRaw(requestParameters: PlayerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Player>>> {
            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.annotations) {
                        queryParameters['annotations'] = requestParameters.annotations;
                    }

                    if (requestParameters.birthdate !== undefined) {
                            queryParameters['birthdate'] = requestParameters.birthdate;
                    }

                    if (requestParameters.contract_expires !== undefined) {
                            queryParameters['contract_expires'] = requestParameters.contract_expires;
                    }

                    if (requestParameters.current_team !== undefined) {
                            queryParameters['current_team'] = requestParameters.current_team;
                    }

                    if (requestParameters.domestic_league !== undefined) {
                            queryParameters['domestic_league'] = requestParameters.domestic_league;
                    }

                    if (requestParameters.grid_id !== undefined) {
                            queryParameters['grid_id'] = requestParameters.grid_id;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.is_retired !== undefined) {
                            queryParameters['is_retired'] = requestParameters.is_retired;
                    }

                    if (requestParameters.last_team !== undefined) {
                            queryParameters['last_team'] = requestParameters.last_team;
                    }

                    if (requestParameters.nationality !== undefined) {
                            queryParameters['nationality'] = requestParameters.nationality;
                    }

                    if (requestParameters.only_values) {
                        queryParameters['only_values'] = requestParameters.only_values;
                    }

                    if (requestParameters.ordering) {
                        queryParameters['ordering'] = requestParameters.ordering;
                    }

                    if (requestParameters.previous_names !== undefined) {
                            queryParameters['previous_names'] = requestParameters.previous_names;
                    }

                    if (requestParameters.role !== undefined) {
                            queryParameters['role'] = requestParameters.role;
                    }

                    if (requestParameters.soloq_tracked !== undefined) {
                            queryParameters['soloq_tracked'] = requestParameters.soloq_tracked;
                    }

                    if (requestParameters.vlr_id !== undefined) {
                            queryParameters['vlr_id'] = requestParameters.vlr_id;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/Player/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async list(requestParameters: PlayerListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Player>> {
                    const response = await this.playerListRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async playerPatchRaw(requestParameters: PlayerPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Player>> {
                    if (requestParameters.id === null || requestParameters.id === undefined) {
                    throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling playerPatch.');
                    }

            const queryParameters: any = {};

            const headerParameters: runtime.HTTPHeaders = {};

                    headerParameters['Content-Type'] = 'application/json';

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/Player/item/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
                                body: requestParameters.patched_player,
            }, initOverrides);

                                return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async patch(requestParameters: PlayerPatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Player> {
                    const response = await this.playerPatchRaw(requestParameters, initOverrides);
                    return await response.value();
                }

            /**
            */
            async playerVariableDistributionRaw(requestParameters: PlayerVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AgentVariableDistribution200ResponseInner>>> {
                    if (requestParameters.bucket_size === null || requestParameters.bucket_size === undefined) {
                    throw new runtime.RequiredError('bucket_size','Required parameter requestParameters.bucket_size was null or undefined when calling playerVariableDistribution.');
                    }

                    if (requestParameters.max === null || requestParameters.max === undefined) {
                    throw new runtime.RequiredError('max','Required parameter requestParameters.max was null or undefined when calling playerVariableDistribution.');
                    }

                    if (requestParameters.metric === null || requestParameters.metric === undefined) {
                    throw new runtime.RequiredError('metric','Required parameter requestParameters.metric was null or undefined when calling playerVariableDistribution.');
                    }

                    if (requestParameters.min === null || requestParameters.min === undefined) {
                    throw new runtime.RequiredError('min','Required parameter requestParameters.min was null or undefined when calling playerVariableDistribution.');
                    }

            const queryParameters: any = {};

                    if (requestParameters.additional_filters !== undefined) {
                            queryParameters['additional_filters'] = requestParameters.additional_filters;
                    }

                    if (requestParameters.birthdate !== undefined) {
                            queryParameters['birthdate'] = requestParameters.birthdate;
                    }

                    if (requestParameters.bucket_size !== undefined) {
                            queryParameters['bucket_size'] = requestParameters.bucket_size;
                    }

                    if (requestParameters.contract_expires !== undefined) {
                            queryParameters['contract_expires'] = requestParameters.contract_expires;
                    }

                    if (requestParameters.current_team !== undefined) {
                            queryParameters['current_team'] = requestParameters.current_team;
                    }

                    if (requestParameters.domestic_league !== undefined) {
                            queryParameters['domestic_league'] = requestParameters.domestic_league;
                    }

                    if (requestParameters.grid_id !== undefined) {
                            queryParameters['grid_id'] = requestParameters.grid_id;
                    }

                    if (requestParameters.id !== undefined) {
                            queryParameters['id'] = requestParameters.id;
                    }

                    if (requestParameters.is_retired !== undefined) {
                            queryParameters['is_retired'] = requestParameters.is_retired;
                    }

                    if (requestParameters.last_team !== undefined) {
                            queryParameters['last_team'] = requestParameters.last_team;
                    }

                    if (requestParameters.max !== undefined) {
                            queryParameters['max'] = requestParameters.max;
                    }

                    if (requestParameters.metric !== undefined) {
                            queryParameters['metric'] = requestParameters.metric;
                    }

                    if (requestParameters.min !== undefined) {
                            queryParameters['min'] = requestParameters.min;
                    }

                    if (requestParameters.nationality !== undefined) {
                            queryParameters['nationality'] = requestParameters.nationality;
                    }

                    if (requestParameters.previous_names !== undefined) {
                            queryParameters['previous_names'] = requestParameters.previous_names;
                    }

                    if (requestParameters.role !== undefined) {
                            queryParameters['role'] = requestParameters.role;
                    }

                    if (requestParameters.soloq_tracked !== undefined) {
                            queryParameters['soloq_tracked'] = requestParameters.soloq_tracked;
                    }

                    if (requestParameters.vlr_id !== undefined) {
                            queryParameters['vlr_id'] = requestParameters.vlr_id;
                    }

            const headerParameters: runtime.HTTPHeaders = {};

                        if (this.configuration && this.configuration.apiKey) {
                        headerParameters["Authorization"] = <string>this.configuration.apiKey("Authorization"); // tokenAuth authentication
                        }

            const response = await this.request({
            path: `/Player/operations/variable-distribution`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
            }, initOverrides);

                            return new runtime.JSONApiResponse(response);
            }

            /**
            */
                async variable_distribution(requestParameters: PlayerVariableDistributionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AgentVariableDistribution200ResponseInner>> {
                    const response = await this.playerVariableDistributionRaw(requestParameters, initOverrides);
                    return await response.value();
                }

        }
